import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {EmailDashboardComponent} from './email-dashboard.component';

export const emailDashboardRoutes: Routes = [
  {
    path : 'email-dashboard',
    component: EmailDashboardComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(emailDashboardRoutes)],
  exports: [RouterModule]
})
export class EmailDashboardRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard-routing.module.ts